import React from "react";
import { Typography, Divider, Space } from "antd";
import { ResultsTable } from "../components/ResultsContent";
import ProgressBarCustom from "../components/Progress";

export default function ResultsPage({ surveyResults, currentCategory }) {
  return (
    <div
      style={{
        paddingLeft: "5%",
        paddingTop: "10px",
        paddingRight: "5%",
        textAlign: "center",
      }}
    >
      <ProgressBarCustom surveyResults={surveyResults} />
      <Typography.Title level={3} style={{ paddingTop: "10px" }}>
        Congratulations on completing the soul care wheel assesment!
      </Typography.Title>
      <Typography.Text style={{ fontSize: "17px" }}>
        This is just the starting point in understanding what may be
        contributing to your stress, blocking your energy, and creating
        “dis-ease” in your body.{" "}
      </Typography.Text>
      <Space direction="vertical">
        <Typography.Text style={{ fontSize: "15px" }}>
          Your quality of life is directly related to how you think, feel, and
          act and your responses and scores in each dimension are a snapshot of
          where you are right now in your well-being journey. Your assessment
          can change as you develop better stress-coping methods as the goal in
          each dimension is to move from stagnation to thriving to experience
          optimal living.
        </Typography.Text>
        <Typography.Text style={{ fontSize: "15px" }}>
          We invite you to join the Soul Abode Community of Practice where we
          come together to explore transformation, innovation, and a mind shift
          around self-care. It’s a community where we provide tools, modalities,
          principles, coaching, and curated groups to build daily practices that
          help change behaviors to support longevity.
        </Typography.Text>
        <Typography.Link
          href="https://links.geneva.com/invite/1b40f55f-0057-45e4-99fd-9c7d7279c8a2"
          target="_blank"
          style={{ fontSize: "17px" }}
        >
          Click here to join us
        </Typography.Link>
      </Space>
      <Divider type="horizontal" plain></Divider>
      <ResultsTable key={currentCategory} surveyResults={surveyResults} />
    </div>
  );
}
